import React from 'react'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'
import SadiaNazeer_Cv from '../../../assets/F_Social_science_Cv/English/Sadia_Nazeer_cv.pdf'

const English = () => {
  return (
    <>
    <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>English</h2>
     
        <p>Faculty of English.</p>
      </div>

      <div className="row">

      <TeacherCard
      name='Dr. Sadia Nazeer '
      profile_name='Assistant Professor, Department of English Language & Literature'
      intro='Assistant Professor Department of English Shaheed Benazir Bhutto Women University, Peshawar'
      email='sadia.nazeer@sbbwu.edu.pk '
      cv={SadiaNazeer_Cv}
      google='https://www.google.com/'
      linkedin=''

      />
   
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>



      <Footer/>
    </>
  )
}

export default English
